<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding fuwuzhichi_section1 section">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated news_sun_ziti1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">服务与支持</p>
        <p class="p2 animate zoomIn animated news_sun_ziti2"
          style="color: #e40230;font-weight: 500; animation-duration: 1s; animation-delay: 1s; visibility: visible;">
          SERVICE AND SUPPORT</p>
        <!-- <P class="p3 animate fadeInUp animated news_sun_ziti3"
          style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
      </div>
    </section>
    <!-- Map Area End -->
    <!-- 合作伙伴 starts -->

    <section class="section">
      <div class="container fuwuzhichi_sun1">

        <!----手机控制器----->
        <div class="toggle_phone" style="display: none;">
          <button id="toggleButton" style="background: none;border: none;
    padding: 4px 6px;
    font-size: 16px;
    color: rgb(255, 255, 255);
    width: 40%;
color: #000;
font-weight:600;
/*     height: 70px; */
    margin-right: 30px;
    float: left;
    right: 1px;
height: 40px;
/*     z-index: 100;
    right: 14px; */
/*     border-radius: 57px; */
">点击选择栏目</button>
        </div>


        <!--手机端左侧开始-->
        <div class="sun_left" id="toggleDivzzy">


          <!--循环start-->
          <div v-for="(item, index) in tablelist" :key="index" class="nei01">
            <div class="neititle">{{ item.name }}
              <img width="16px" src="../../static/assets/images/xiala1.png">
            </div>
            <ul>
              <li v-for="(itema, indexa) in item.son" :key="indexa" @click="fuwuinfoanb(itema.scode)">{{ itema.name }}</li>
            </ul>
          </div>
          <!--循环stop-->




          <!--循环start-->
          <!-- <div class="nei01">
					<div class="neititle">Dimetix知识库</div>
					<ul>
						<li>附件</li>
						<li>设置</li>
						<li>维护</li>
						<li>软件</li>
						<li>视频</li>
						<li>测量性能</li>
						<li>通讯接口</li>
						<li>光学</li>
					</ul>
				</div> -->
          <!--循环stop-->
          <!--循环start-->
          <!-- <div class="nei01">
					<div class="neititle">Dimetix手册</div>
					<ul>
						<li>分类下载</li>
						<li>产品下载</li>
					</ul>
				</div> -->
          <!--循环stop-->




        </div>
        <!--左侧结束-->


        <!--电脑端左侧开始-->
        <div class="sun_left diannaolist">


          <!--循环start-->
          <div v-for="(item, index) in tablelist" :key="index" class="nei01">
            <div class="neititle">{{ item.name }}</div>
            <ul>
              <li v-for="(itema, indexa) in item.son" :key="indexa" @click="fuwuinfoan(itema.scode)">{{ itema.name }}</li>
            </ul>
          </div>
          <!--循环stop-->




          <!--循环start-->
          <!-- <div class="nei01">
					<div class="neititle">Dimetix知识库</div>
					<ul>
						<li>附件</li>
						<li>设置</li>
						<li>维护</li>
						<li>软件</li>
						<li>视频</li>
						<li>测量性能</li>
						<li>通讯接口</li>
						<li>光学</li>
					</ul>
				</div> -->
          <!--循环stop-->
          <!--循环start-->
          <!-- <div class="nei01">
					<div class="neititle">Dimetix手册</div>
					<ul>
						<li>分类下载</li>
						<li>产品下载</li>
					</ul>
				</div> -->
          <!--循环stop-->




        </div>
        <!--左侧结束-->

        <!--右侧开始-->
        <div class="sun_right" id="younei">
          <div class="nei01">
            <div class="neititle">当前栏目：{{ fuwuname }}</div>
          </div>
          <div
            style="width: 100%;    display: table; border-radius: 15px; border: 2px solid #cccccc;background: #ffffff;margin-top: 30px;">
            <div style="width: 90%;margin-left: 5%;padding-top:20px; padding-bottom: 20px;line-height: 40px;float: left;">
              <p v-html="fuwuinfo.content"></p>
            </div>
            <div
              style="width: 90%;margin-left: 5%;padding-top:20px; padding-bottom: 20px;line-height: 40px;float: left; color: rgb(156 156 156);">
              <span style="padding: 0px 10px;font-size: 16px;"><i class="fa fa-eye" style="color:#44bcb9;"></i>
                {{ fuwuinfo.visits }} </span>
              <!-- <span style="padding: 0px 10px; font-size: 14px;"><i class="fa fa-heart" style="color:#44bcb9;"></i> {{}} </span> -->
              <span style="padding: 0px 10px; font-size: 16px;"> {{ fuwuinfo.date }} </span>

            </div>

          </div>
        </div>
        <!--右侧结束-->
      </div>

    </section>

    <!-- 合作伙伴 end -->

  </div>
</template>
<style>
body {
  background: #ebf0f4 !important;
}
</style>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      isMobile: false,
      fuwuinfo: [],

      fuwuname: '服务宗旨',
      fuwuid: 34,

      fuwulist: [],
      tablelist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    if(this.$route.query.id){
      this.fuwuid = this.$route.query.id;
    }
    this.checkIfMobile();
    
    // script.js
    document.addEventListener('DOMContentLoaded', () => {
      const toggleButton = document.getElementById('toggleButton');
      const toggleDiv = document.getElementById('toggleDivzzy');
      // const youneiDiv = document.getElementById('younei');

      toggleButton.addEventListener('click', () => {
        
        if (toggleDiv.style.display === 'none' || toggleDiv.style.display === '') {
          toggleDiv.style.display = 'block';
          // youneiDiv.style.display = 'none';
        } else {
          toggleDiv.style.display = 'none';
          // youneiDiv.style.display = 'none';
        }
      });
    });
    //获取左侧分类
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.fuwulist = response.data.data;
        this.tablelist = this.fuwulist[3]['son'][0]['son'];
        console.log(this.fuwulist[3]['son'][0]['son']);


      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/25', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    this.fuwuinfoan(this.fuwuid)
  },
  methods: {
    checkIfMobile() {
      var isMobile = window.innerWidth <= 800;  // 假设 768px 以下为手机
      console.log('Is Mobile:', isMobile);
      if(isMobile==true){
        this.yincangdivb()
      }else{
        this.yincangdiv()
      }
    },
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },

    yincangdiv() {
      const toggleDivb = document.getElementById('toggleDivzzy');
      toggleDivb.style.display = 'none';
    },
    yincangdivb() {
      console.log(22222)
      const toggleDivz = document.getElementById('toggleDivzzy');
      toggleDivz.style.display = 'block';
    },
 


    fuwuinfoan(e) {

      //获取右侧点击内容
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          this.fuwuinfo = response.data.data;
          this.fuwuname = response.data.data.title;
          this.fuwuid = response.data.data.id;

        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
      // this.yincangdiv()
      // fuwuid
    },
    fuwuinfoanb(e) {

      //获取右侧点击内容
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          this.fuwuinfo = response.data.data;
          this.fuwuname = response.data.data.title;
          this.fuwuid = response.data.data.id;

        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
      this.yincangdiv()
      
      // fuwuid
      }


  }
};
</script>




// WEBPACK FOOTER //
// Fuwu.vue?4eb780a2